import React from 'react';
import * as emotion from 'emotion';
import * as emotionCore from '@emotion/core';
import * as emotionTheming from 'emotion-theming';
let hasAutomatBeenSet = false;
export const setAutomat = () => {
    if (!hasAutomatBeenSet) {
        window.guardian.automat = {
            react: React,
            preact: React,
            emotionCore,
            emotionTheming,
            emotion,
        };
        hasAutomatBeenSet = true;
    }
};
